var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcOobcCone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.84819 21.3766C7.58924 20.0373 11.3383 19.015 15.7154 18.861C20.3785 18.6969 24.4027 19.5606 26.067 20.9249",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinejoin: "round",
    strokeDasharray: "0.91 0.91"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26.6176 20.7907L15.92 2.67578L5.22245 20.7907C5.08074 21.0169 5.00363 21.2801 5 21.5499C5 23.647 9.88973 25.3247 15.92 25.3247C21.9503 25.3247 26.84 23.647 26.84 21.5499C26.8364 21.2801 26.7593 21.0169 26.6176 20.7907Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcOobcCone);
export default __webpack_public_path__ + "static/media/ic_OOBC_cone.51a45fcdfb2626551b6e58b32c42980c.svg";
export { ForwardRef as ReactComponent };